import { IonButton, IonText, useIonRouter } from '@ionic/react';
import { createSelector } from '@reduxjs/toolkit';
import { alertCircleOutline } from 'ionicons/icons';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { t } from 'ttag';

import { Icon } from '@components/Icon';
import KioskLayout, { LockMode } from '@components/KioskLayout';
import { useCountdown } from '@hooks/useCountdown';
import { getKioskColor } from '@state/event';
import { getKioskEnabled } from '@state/kiosk';

const Footer = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

const Button = styled(IonButton)`
  margin-top: 16px;
  padding: 0px 16px;
`;

const CountdownText = styled.p`
  margin-top: 0;
  text-align: center;
`;

const selector = createSelector(getKioskEnabled, getKioskColor, (kioskEnabled, kioskColor) => ({
  kioskEnabled,
  kioskColor,
}));

export const CheckErrorContent = () => {
  const { kioskEnabled, kioskColor } = useSelector(selector);
  return (
    <>
      <Icon
        $color={(kioskEnabled && kioskColor) || '--ion-color-danger'}
        icon={alertCircleOutline}
        color="danger"
      />
      <IonText color="danger">
        {t`Error occurred while scanning. We couldn't find a person with this Check In code during the scan. Please try again.`}
      </IonText>
    </>
  );
};

export const CheckError = () => {
  const { kioskEnabled } = useSelector(selector);
  const router = useIonRouter();
  const goBack = useCallback(() => {
    router.goBack();
  }, [router]);
  const countdown = useCountdown(goBack);

  return (
    <KioskLayout
      lockMode={kioskEnabled ? LockMode.Lock : LockMode.None}
      footer={
        <Footer>
          <CountdownText>{t`You will be redirected in ${countdown}...`}</CountdownText>
          <Button expand="block" fill="outline" onClick={goBack}>{t`Done`}</Button>
        </Footer>
      }
    >
      <CheckErrorContent />
    </KioskLayout>
  );
};
